package music.limasoul.client.shared.event.domain.usecase

import music.jammers.client.shared.event.domain.repository.EventRepository
import music.jammers.shared.event.domain.model.EventDetails

class SortEventTrackUseCase(
    private val eventRepository: EventRepository,
) {

    suspend operator fun invoke(eventId: Long): EventDetails =
        eventRepository.sort(eventId)
}